/**
 * Supported data residency regions.
 * Each region maps to an Azure region where tenant data is stored.
 * primaryFrameworks lists the frameworks most relevant to clients in that region.
 */
export const REGIONS = {
    ksa: {
        id: 'ksa',
        label: 'Saudi Arabia / GCC',
        azureRegion: 'uaenorth',
        primaryFrameworks: [
            'ndmo', 'pdpl', 'nca-ecc', 'cybersecurity',
            'iso-27001', 'iso-27701', 'iso-31000', 'iso-22301',
        ],
    },
    eu: {
        id: 'eu',
        label: 'European Union / UK',
        azureRegion: 'westeurope',
        primaryFrameworks: [
            'gdpr', 'uk-gdpr', 'dora', 'eu-mdr', 'mhra',
            'iso-27001', 'iso-27701', 'iso-42001',
        ],
    },
    us: {
        id: 'us',
        label: 'United States',
        azureRegion: 'eastus',
        primaryFrameworks: [
            'hipaa', 'fda', 'ccpa', 'soc-2', 'pci-dss',
            'cmmc', 'sox', 'nist-ai-rmf', 'cybersecurity',
        ],
    },
};
export const REGION_LIST = Object.values(REGIONS);
//# sourceMappingURL=regions.js.map